import { render, staticRenderFns } from "./askLeaveSp.vue?vue&type=template&id=0e34ccc6&"
import script from "./askLeaveSp.vue?vue&type=script&lang=js&"
export * from "./askLeaveSp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports